<template>
  <modal wrapperClasses="passcode">
    <div slot="body" class="modal-content">
      <passcode-input
        :passcode.sync="passcode"
        autocomplete="new-password" />
      <div v-if="error" class="error">{{ error }}</div>
      <div class="content">enter your PIN to continue</div>
    </div>
    <div slot="action" class="modal-click-action">
      <div class="remember_me">
        <sb-checkbox :checked.sync="rememberMe" />
        <label for="remember">remember me</label>
      </div>
      <button @click="clickedEnter()" class="button submit">enter</button>
    </div>
    <div slot="footer" class="modal-footer">
      <div @click="clickedForgotPin()" class="link">forgot PIN?</div>
    </div>
  </modal>
</template>

<script>
  import Modal from '../../components/shared/Modal'
  import PasscodeInput from '../../components/shared/PasscodeInput'
  import { passcodeAPI } from "../../services/api/passcode"

  export default {
    name: 'EnterPasscodeModal',

    data() {
      return {
        error: '',
        passcode: '',
        rememberMe: true
      }
    },

    components: {
      Modal,
      PasscodeInput
    },

    computed: {
      encodedSecureLinkId(){
        return this.$route.params.id
      }
    },

    methods: {
      clearError(){
        return this.error = ''
      },

      clickedEnter(){
        if(!this.passcode) return this.error = 'must enter PIN'
        return passcodeAPI.getCheckMemberPasscode(
                this.encodedSecureLinkId,
                this.passcode,
                this.rememberMe
              )
              .then(data => {
                this.$router.push({
                  name: 'Stashboard',
                  params: {
                    id: this.encodedSecureLinkId,
                    anyLinks: data.any_link_extensions,
                    appStoreUrl: data.app_store_url,
                    content: data.sms_content,
                    extensionType: data.type,
                    googlePlayUrl: data.google_play_url,
                    merchantName: data.merchant_name,
                    merchantWebsiteUrl: data.website,
                    stashboardHeaders: data.stashboard_headers,
                    urlButton: data.url,
                    urlImage: data.mms_cdn_link
                  }
                })
              }).catch(error => this.error = 'invalid PIN')
      },

      clickedForgotPin(){
        this.error = ''
        this.$emit('clickedForgotPin')
      }
    },

    watch: {
      passcode(){
        this.clearError()
      }
    }
  }
</script>